import React, { useState } from "react";
import { SideMenu, DateRangePicker } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import "./student-panel-invoice.css";
import { useNavigate } from "react-router-dom";
let Invoice = () => {
  const navigate = useNavigate();
  let [TableData, setTableData] = useState([
    {
      date: "JAN 4, 2022",
      id: "#12345678",
      studentName: "Willow Anderson",
      des: "Lorem ipsum dolor sit a...",
      amount: "$2000",
      status: "Due in 22 days",
      buttonTitle: "Make a payment",
    },
    {
      date: "JAN 4, 2022",
      id: "#12345678",
      studentName: "Willow Anderson",
      des: "Lorem ipsum dolor sit a...",
      amount: "$5000",
      status: "Overdue",
      buttonTitle: "Make a payment",
    },
    {
      date: "JAN 4, 2022",
      id: "#12345678",
      studentName: "Willow Anderson",
      des: "Lorem ipsum dolor sit a...",
      amount: "$3000",
      status: "Paid",
      buttonTitle: "Preview",
    },
    {
      date: "JAN 4, 2022",
      id: "#12345678",
      studentName: "Willow Anderson",
      des: "Lorem ipsum dolor sit a...",
      amount: "$3000",
      status: "Paid",
      buttonTitle: "Preview",
    },
    {
      date: "JAN 4, 2022",
      id: "#12345678",
      studentName: "Willow Anderson",
      des: "Lorem ipsum dolor sit a...",
      amount: "$2000",
      status: "Paid",
      buttonTitle: "Preview",
    },
    {
      date: "JAN 4, 2022",
      id: "#12345678",
      studentName: "Willow Anderson",
      des: "Lorem ipsum dolor sit a...",
      amount: "$5000",
      status: "Paid",
      buttonTitle: "Preview",
    },
    {
      date: "JAN 4, 2022",
      id: "#12345678",
      studentName: "Willow Anderson",
      des: "Lorem ipsum dolor sit a...",
      amount: "$3000",
      status: "Paid",
      buttonTitle: "Preview",
    },
    {
      date: "JAN 4, 2022",
      id: "#12345678",
      studentName: "Willow Anderson",
      des: "Lorem ipsum dolor sit a...",
      amount: "$3000",
      status: "Paid",
      buttonTitle: "Preview",
    },
  ]);
  return (
    <SideMenu>
      <div className="page-container">
        <div>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={3} lg={3} md={3} sm={7} xs={12}>
                <div>
                  <p className="header-input-heading">Search by Invoice ID</p>
                  <input
                    type="text"
                    className="header-input"
                    placeholder="Search by Invoice ID"
                  />
                </div>
              </Grid>
              <Grid item xl={2} lg={2} md={2} sm={5} xs={12}>
                <div>
                  <p className="header-input-heading">Status</p>
                  <select className="header-dropdown">
                    <option value="all">All</option>
                    <option value="Paid">Paid</option>
                    <option value="Overdue">Overdue</option>
                  </select>
                </div>
              </Grid>
              <Grid item xl={5} lg={5} md={5} sm={9} xs={12}>
                <DateRangePicker />
              </Grid>
              <Grid item xl={2} lg={2} md={2} sm={3} xs={12}>
                <div>
                  <Button className="header-apply-button" variant="text">
                    <p className="header-apply-button-text">Apply</p>
                  </Button>
                </div>
              </Grid>
            </Grid>
            <br />
          </Box>
          <br />
          <div className="table-container">
            <div className="table-data-container">
              <table>
                <thead>
                <tr>
                  <th className="invoice-table-id-heading">Invoice ID</th>
                  <th className="invoice-table-date-heading">Date</th>
                  <th className="invoice-table-description-heading">
                    Discription
                  </th>
                  <th className="invoice-table-student-name-heading">name</th>
                  <th className="invoice-table-send-heading">Tax (%)</th>
                  <th className="invoice-table-amount-heading">Total amount</th>
                  <th className="invoice-table-status-heading">Status</th>
                  <th className="invoice-table-status-heading"></th>
                </tr>
                </thead>
                {TableData.map((tableValue, tableIndex) => {
                  return (
                    <tr key={tableIndex}>
                      <td className="table-id-data">{tableValue.id}</td>
                      <td className="table-data">{tableValue.date}</td>
                      <td className="table-data">{tableValue.des}</td>
                      <td className="table-data">{tableValue.studentName}</td>
                      <td className="table-center-data">5%</td>
                      <td className="table-center-data">{tableValue.amount}</td>
                      <td className="table-data">
                        <div
                          className="invoice-table-status-button"
                          style={{
                            backgroundColor:
                              tableValue.status === "Paid"
                                ? "#098B51"
                                : tableValue.status === "Overdue"
                                ? "#EB4040"
                                : "#663399",
                            color: "#fff",
                          }}
                        >
                          {tableValue.status}
                        </div>
                      </td>
                      <td className="table-data">
                        <Button
                          onClick={() =>
                            navigate("/student-panel/invoice/view")
                          }
                          className="student-panel-invoice-table-button"
                          style={{
                            backgroundColor:
                              tableValue.status === "Paid"
                                ? "#098B51"
                                : tableValue.status === "Overdue"
                                ? "#EB4040"
                                : "#663399",
                            color: "#fff",
                          }}
                        >
                          {tableValue.buttonTitle}
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </table>
            </div>
            <div className="table-pagination-main">
              <Stack spacing={2}>
                <Pagination count={10} variant="outlined" shape="rounded" />
              </Stack>
            </div>
          </div>
        </div>
      </div>
    </SideMenu>
  );
};
export default Invoice;
